import { render, staticRenderFns } from "./ListEvents.vue?vue&type=template&id=a60a7e7c&"
import script from "./ListEvents.vue?vue&type=script&lang=ts&"
export * from "./ListEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports